<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.26</b> - Размеры шрифта, производительность и исправления ошибок</p>
    <div class="ml-5 pb-4 text-yellow-300">
      <div class="font-bold mt-2">Улучшения качества жизни</div>
      <ul class="ml-4 list-disc">
        <li>Увеличены размеры шрифта и улучшена читаемость текста во всей игре</li>
      </ul>

      <div class="font-bold mt-2">ИИ боя</div>
      <ul class="ml-4 list-disc">
        <li>Исправлена ошибка, из-за которой дальнобойные бойцы пропускали ходы.</li>
      </ul>

      <div class="font-bold mt-2">Исправления ошибок и производительность</div>
      <ul class="ml-4 list-disc">
        <li>
          Исправлены проблемы с отображением боевого экрана при сворачивании и возвращении в игру.
        </li>
        <li>Таверна: исправлена ошибка, из-за которой игроки застревали в боевом состоянии.</li>
        <li>Исправлен и оптимизирован механизм обновления состояния турнира в таверне.</li>
        <li>Исправлено получение наград турнира в таверне.</li>
        <li>
          Исправлено несколько утечек памяти в UI и другие ошибки при закрытии экранов интерфейса.
        </li>
      </ul>
    </div>
  </div>
</template>
